module.exports = __webpack_public_path__ + "img/q10.01737cc6.jpeg";